"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    ref: "dialog",
    class: "bug-dialog"
};
const _hoisted_2 = { class: "center" };
const _hoisted_3 = {
    href: "https://github.com/terraforming-mars/terraforming-mars/issues/new?template=from-heroku.md",
    target: "_blank"
};
const _hoisted_4 = {
    href: "https://discord.com/channels/737945098695999559/742721510376210583",
    target: "_blank"
};
const _hoisted_5 = { class: "dialog-menu centered-content" };
const _hoisted_6 = { method: "dialog" };
const _hoisted_7 = { class: "btn btn-lg" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("dialog", _hoisted_1, [
        (0, vue_1.createElementVNode)("p", _hoisted_2, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[2] || (_cache[2] = [
                    (0, vue_1.createTextVNode)("Copy the text below and then paste it in", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            _cache[6] || (_cache[6] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_3, [...(_cache[3] || (_cache[3] = [
                    (0, vue_1.createTextVNode)("a GitHub issue", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[4] || (_cache[4] = [
                    (0, vue_1.createTextVNode)("or the", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            _cache[7] || (_cache[7] = (0, vue_1.createTextVNode)()),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_4, [...(_cache[5] || (_cache[5] = [
                    (0, vue_1.createTextVNode)("#bug-reports Discord channel", -1)
                ]))])), [
                [_directive_i18n]
            ])
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("textarea", {
            ref: "textarea",
            readonly: "",
            rows: "6",
            cols: "50",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.message) = $event))
        }, null, 512), [
            [vue_1.vModelText, _ctx.message]
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_5, [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                    class: "btn btn-lg btn-primary",
                    onClick: _cache[1] || (_cache[1] =
                        (...args) => (_ctx.copyTextArea && _ctx.copyTextArea(...args)))
                }, [...(_cache[8] || (_cache[8] = [
                        (0, vue_1.createTextVNode)("Copy to Clipboard", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    class: (0, vue_1.normalizeClass)({ center: true, invisible: !_ctx.showCopied })
                }, [...(_cache[9] || (_cache[9] = [
                        (0, vue_1.createTextVNode)("Copied!", -1)
                    ]))], 2)), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("form", _hoisted_6, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", _hoisted_7, [...(_cache[10] || (_cache[10] = [
                        (0, vue_1.createTextVNode)("Close", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ])
    ], 512));
}
